import React, { useMemo } from 'react';
import { Badge } from 'reactstrap';
import { UserResponse } from '@business/entities/account';

const DAY_ORDER = ['M', 'T', 'W', 'R', 'F', 'S', 'U'];
const DAY_MAP: Record<string, string> = { M: 'Mon', T: 'Tue', W: 'Wed', R: 'Thu', F: 'Fri', S: 'Sat', U: 'Sun' };

export function getEstimatorLabel(e: UserResponse): string {
  const name = `${e.firstName} ${e.lastName}`.trim();
  const codes = new Set((e.openings ?? []).flatMap(o => o.days));
  const days = DAY_ORDER.filter(d => codes.has(d)).map(d => DAY_MAP[d]);
  return days.length > 0 ? `${name} · ${days.join(', ')}` : name;
}

export interface EstimatorAvailabilityBadgeProps {
  estimator: UserResponse;
  className?: string;
}

export const EstimatorAvailabilityBadge: React.FC<EstimatorAvailabilityBadgeProps> = ({ estimator, className }) => {
  const workingDaysText = useMemo(() => {
    const codes = new Set((estimator.openings ?? []).flatMap(o => o.days));
    const days = DAY_ORDER.filter(d => codes.has(d)).map(d => DAY_MAP[d]);
    if (days.length === 0) return 'No schedule set';
    if (days.length === 7) return 'All days';
    return days.join(', ');
  }, [estimator.openings]);

  return (
    <div className={className}>
      {/* <div className="mb-2">
        <strong>{estimator.firstName} {estimator.lastName}</strong>
      </div> */}
      <div>
        <small className="text-muted">
          Works: <Badge color="info">{workingDaysText}</Badge>
        </small>
      </div>
    </div>
  );
};
